import type { TransitionStatus } from 'react-transition-group/Transition';
import styled from 'styled-components';

import { SpacedItems } from '#@/components/SpacedItems';
import { COLOR, mixins, textStyles } from '#@/shared/utils/styles';
import { isEntered } from '#@/shared/utils/transitionStates';

import { TOOLBAR_HEIGHT, TOOLBAR_TRANSITION_DURATION } from '../constants';

export const Container = styled(SpacedItems)<{ $transitionState: TransitionStatus }>`
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  align-items: center;
  background-color: ${COLOR.white};
  flex-shrink: 0;
  height: ${TOOLBAR_HEIGHT}px;
  padding: 0 20px;
  position: fixed;
  transition: transform ${TOOLBAR_TRANSITION_DURATION}ms ease-out;
  width: 100%;
  z-index: 1;
  transform: translateY(${(props) => (isEntered(props.$transitionState) ? 0 : -TOOLBAR_HEIGHT)}px);
`;

export const Title = styled.div`
  color: ${COLOR.textPrimary};
  ${textStyles.labelLarge500}
  ${mixins.truncateText()}
  margin-left: 20px;
`;

export const PageCount = styled.div`
  color: ${COLOR.textSecondary};
  ${textStyles.labelMedium500}
  min-width: 70px;
  margin: 0 20px;
  text-align: center;
`;
